/*
  Klaviyo back-in-stock registration for the product page — extracted from
  sections/main-product.liquid so it ships deferred from a cacheable asset.

  Klaviyo is loaded by layout/theme.liquid on the first user interaction, so it does not
  exist when this inline script runs. Registering the back-in-stock form here instead of
  calling klaviyo.init/enable directly: the loader drains this queue once klaviyo.enable is
  callable, and pushes made after that point run immediately.
  
  Do not init Klaviyo from here and do not touch __klaviyoThemeInited — that flag belongs to
  the loader, and setting it from a DOMContentLoaded handler made the loader skip fetching
  Klaviyo entirely, which silently broke this form on every product page.
*/
function modalStylesheetUrl() {
  var tag = document.querySelector('script[data-klaviyo-bis-stylesheet]');
  return tag ? tag.getAttribute('data-klaviyo-bis-stylesheet') : '';
}

window.__klaviyoReadyCallbacks = window.__klaviyoReadyCallbacks || [];
  window.__klaviyoReadyCallbacks.push(function () {
    if (window.__klaviyoBisEnabled) return;
    window.__klaviyoBisEnabled = true;
    window.klaviyo.enable("backinstock", {
    trigger: {
      product_page_text: "Notify Me When Available",
      product_page_class: "button",
      product_page_text_align: "center",
      product_page_margin: "0px",
      replace_anchor: false
    },
    modal: {
     headline: "{product_name}",
     body_content: "Register to receive a notification when this item comes back in stock.",
     email_field_label: "Email",
     button_label: "Notify me when available",
     subscription_success_label: "You're in! We'll let you know when it's back.",
     footer_content: '',
     font_family: "faricy-new-web, sans-serif",
     additional_styles: "@import url('" + modalStylesheetUrl() + "');",
     drop_background_color: "#000",
     background_color: "#fff",
     text_color: "#121212",
     button_text_color: "#fff",
     button_background_color: "#1e1e1e",
     close_button_color: "#121212",
     error_background_color: "#ece9e3",
     error_text_color: "#C72E2F",
     success_background_color: "#d3efcd",
     success_text_color: "#1B9500"
    }
  });
  });
